import { StyleSheet } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors'
import { typography } from '../../shared/theme/typography';

export const catalogProductFormStyles = StyleSheet.create({
  // Proto ticket form (alta): sec / label / inp
  // Sections are separated by dividers (see sectionDivider) + parent gap.
  ticketFormSection: {
    gap: 4,
  },
  sectionDivider: {
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
    paddingTop: 16,
    marginTop: 4,
  },
  sectionTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  ticketFormSectionTitle: {
    fontSize: 11,
    lineHeight: 14,
    fontWeight: '700',
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    marginBottom: 12,
    fontFamily: ticketFonts.sans,
  },
  /** Two-column field grid (desktop). On mobile, falls back to stack via fieldGridMobile. */
  fieldGrid: {
    flexDirection: 'row',
    gap: 12,
  },
  fieldGridItem: {
    flex: 1,
    minWidth: 0,
  },
  fieldGridMobile: {
    flexDirection: 'column',
    gap: 0,
  },
  /** Picker trigger that matches TextInput height/style for grid alignment. */
  pickerTrigger: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  pickerTriggerActive: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
  },
  pickerTriggerText: {
    flex: 1,
    fontSize: 15,
    fontWeight: '500',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  pickerTriggerTextMuted: {
    color: ticketColors.ink3,
  },
  pickerTriggerChev: {
    fontSize: 12,
    color: ticketColors.ink3,
  },
  ticketFormField: {
    gap: 6,
    marginBottom: 14,
  },
  ticketFormLabel: {
    fontSize: 13,
    lineHeight: 17,
    fontWeight: '600',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
  requiredAsterisk: {
    color: ticketColors.bad,
    fontWeight: '700',
  },
  ticketFormInput: {
    minHeight: 44,
    paddingHorizontal: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    fontSize: 15,
    fontWeight: '500',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  ticketInpRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: 8,
  },
  ticketInpRowInput: {
    flex: 1,
    minWidth: 0,
  },
  ticketScanBtn: {
    width: 40,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
  },
  itemTypeField: {
    marginTop: 8,
  },
  formSegmentRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  formSegmentButton: {
    flexGrow: 0,
    flexShrink: 0,
    minHeight: 44,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    borderRadius: 8,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 7,
  },
  formSegmentButtonActive: {
    backgroundColor: ticketColors.brandPrimary,
    borderColor: ticketColors.brandPrimary,
  },
  formSegmentText: {
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
    textAlign: 'center',
  },
  formSegmentTextActive: {
    color: ticketColors.goldInk,
    fontWeight: '700',
  },
  ticketFormHint: {
    fontSize: 11,
    fontWeight: '500',
    color: ticketColors.ink3,
    lineHeight: 14,
    fontFamily: ticketFonts.sans,
  },
  inputHelper: {
    fontSize: 11,
    fontWeight: '500',
    color: ticketColors.ink3,
    lineHeight: 14,
    fontFamily: ticketFonts.sans,
  },
  inputHelperError: {
    color: ticketColors.bad,
  },
  costCardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: spacing.sm,
    marginBottom: spacing.xs,
  },
  costMetricsRow: {
    flexDirection: 'row',
    gap: spacing.sm,
    flexWrap: 'wrap',
  },
  costMetric: {
    flexGrow: 1,
    minWidth: 100,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    padding: spacing.xs + 2,
    gap: 2,
  },
  costMetricLabel: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  costMetricValue: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  costMetricValuePositive: {
    color: ticketColors.ok,
  },
  costMetricValueNegative: {
    color: ticketColors.bad,
  },
  priceGuideActionRow: {
    flexDirection: 'row',
    gap: spacing.sm,
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  priceGuideSuggestedBox: {
    flex: 1,
    minWidth: 150,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.paper,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    gap: 2,
  },
  priceGuideSuggestedLabel: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  priceGuideSuggestedValue: {
    fontSize: 20,
    lineHeight: 26,
    fontWeight: '800',
    color: ticketColors.gold,
  },
  suggestButton: {
    flexGrow: 1,
    minWidth: 132,
    maxWidth: 200,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
  },
  categorySelectorTrigger: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 8,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    backgroundColor: ticketColors.paper,
  },
  categorySelectorSelected: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.paper,
  },
  categorySelectorTextBlock: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  categorySelectorLabel: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '500',
  },
  categorySelectorValue: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '600',
  },
  categorySelectorChevron: {
    ...typography.body,
    color: ticketColors.ink2,
    fontWeight: '400',
  },
  noCategoriesHint: {
    marginTop: spacing.sm,
    gap: spacing.sm,
  },
  noCategoriesText: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
  },
  noCategoriesTextMuted: {
    ...typography.caption,
    color: ticketColors.ink3,
    marginTop: spacing.sm,
    lineHeight: 18,
  },
  noCategoriesButton: {
    alignSelf: 'stretch',
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.paper,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.md,
    alignItems: 'center',
    justifyContent: 'center',
  },
  noCategoriesButtonText: {
    ...typography.body,
    color: ticketColors.gold,
    fontWeight: '700',
  },
  validationText: {
    ...typography.caption,
    color: ticketColors.bad,
    fontWeight: '600',
  },
  /** Draft validation notice — proto "!" banner with danger tone. */
  draftNotice: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'rgba(185, 28, 28, 0.22)',
    backgroundColor: '#FEF2F2',
    paddingHorizontal: 12,
    paddingVertical: 10,
  },
  draftNoticeGlyph: {
    fontSize: 14,
    fontWeight: '800',
    color: ticketColors.bad,
    lineHeight: 18,
  },
  draftNoticeText: {
    flex: 1,
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.bad,
    lineHeight: 18,
  },
  /** Image picker helper + warn notice. */
  imageHelper: {
    fontSize: 11,
    fontWeight: '500',
    color: ticketColors.ink3,
    lineHeight: 15,
    marginTop: 4,
  },
  imageWarnNotice: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.warnBorder,
    backgroundColor: ticketColors.warnBg,
    paddingHorizontal: 12,
    paddingVertical: 10,
    marginTop: 8,
  },
  imageWarnNoticeText: {
    flex: 1,
    fontSize: 12,
    fontWeight: '600',
    color: ticketColors.warn,
    lineHeight: 16,
  },
  notesMultiline: {
    height: undefined,
    minHeight: 72,
    textAlignVertical: 'top',
    paddingTop: 10,
    paddingBottom: 10,
    lineHeight: 20,
  },
  packToggle: {
    marginTop: spacing.sm,
  },
  packToggleLabel: {
    ...typography.body,
    color: ticketColors.ink,
  },
  variantCard: {
    marginTop: spacing.sm,
    padding: spacing.sm,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    gap: spacing.xs,
  },
  variantRow: {
    flexDirection: 'row',
    gap: spacing.sm,
  },
  variantFieldHalf: {
    flex: 1,
  },
  variantRemoveButton: {
    alignSelf: 'flex-start',
    paddingVertical: spacing.xs,
    minHeight: 36,
    justifyContent: 'center',
  },
  variantRemoveButtonText: {
    ...typography.caption,
    color: ticketColors.bad,
    fontWeight: '600',
  },
  variantGenerateBarcodeButton: {
    alignSelf: 'flex-start',
    paddingVertical: spacing.xs,
    minHeight: 36,
    justifyContent: 'center',
  },
  variantGenerateBarcodeButtonText: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  variantAddButton: {
    marginTop: spacing.sm,
  },
  variantMatrixPanel: {
    marginTop: spacing.sm,
    padding: spacing.sm,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    gap: spacing.xs,
  },
  variantPresetRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.xs,
  },
  variantPresetChip: {
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 999,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
    minHeight: 36,
    justifyContent: 'center',
  },
  variantPresetChipText: {
    ...typography.caption,
    color: ticketColors.ink2,
  },
  variantMatrixButton: {
    marginTop: spacing.xs,
  },
  // ── Variant table (compact view for many variants) ──
  variantTable: {
    marginTop: spacing.sm,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 8,
    overflow: 'hidden',
  },
  variantTableHeader: {
    flexDirection: 'row',
    backgroundColor: ticketColors.bg,
    paddingVertical: 6,
    paddingHorizontal: 8,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
    gap: 4,
  },
  variantTableHeaderCell: {
    fontSize: 10,
    fontWeight: '700',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
  },
  variantTableRow: {
    flexDirection: 'row',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
    alignItems: 'center',
    gap: 4,
  },
  variantTableInput: {
    minHeight: 40,
    paddingHorizontal: 6,
    paddingVertical: 4,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    fontSize: 13,
    fontWeight: '500',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  variantTableSearchInput: {
    minHeight: 44,
    paddingHorizontal: 10,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    fontSize: 13,
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
    flex: 1,
  },
  modalField: {
    gap: spacing.xs,
  },
  modalLabel: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  suggestionBlock: {
    borderColor: ticketColors.gold,
  },
  lookupHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: spacing.sm,
  },
  blockTitle: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  lookupBadge: {
    ...typography.caption,
    color: ticketColors.goldInk,
    backgroundColor: ticketColors.gold,
    borderRadius: 999,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
    fontWeight: '700',
  },
  lookupName: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
  },

  // ── Mobile (clean design) ──
  mobilePickerTrigger: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    paddingHorizontal: spacing.md,
    paddingVertical: 10,
    backgroundColor: ticketColors.paper,
  },
  mobilePickerSelected: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.paper,
  },
  mobilePickerLabel: {
    fontSize: 12,
    fontWeight: '500',
    color: ticketColors.ink2,
  },
  mobilePickerValue: {
    fontSize: 16,
    fontWeight: '600',
    color: ticketColors.ink,
  },
  mobilePickerChevron: {
    fontSize: 18,
    color: ticketColors.ink2,
  },
  mobileInfoPanel: {
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    padding: spacing.md,
    gap: spacing.sm,
  },
  mobilePanelTitle: {
    fontSize: 14,
    fontWeight: '800',
    color: ticketColors.ink,
  },
  mobileBtnSecondary: {
    minHeight: 42,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.md,
  },
  mobileBtnSecondaryText: {
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  mobileBtnPrimary: {
    minHeight: 42,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.gold,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.md,
  },
  mobileBtnPrimaryText: {
    fontSize: 14,
    fontWeight: '800',
    color: ticketColors.goldInk,
  },
  ticketFormLink: {
    fontSize: 14,
    fontWeight: '600',
    color: ticketColors.goldInk,
    fontFamily: ticketFonts.sans,
  },

  // ── Desktop rail layout (B): nav lateral + panel exclusivo ──
  railBody: {
    flex: 1,
    flexDirection: 'row',
    minHeight: 0,
  },
  rail: {
    width: 230,
    flexGrow: 0,
    flexShrink: 0,
    borderRightWidth: 1,
    borderRightColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.bg,
  },
  railContent: {
    flexGrow: 1,
    paddingVertical: 14,
    paddingHorizontal: 10,
    gap: 2,
  },
  railItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    borderRadius: 9,
    paddingVertical: 9,
    paddingHorizontal: 6,
  },
  railItemActive: {
    backgroundColor: ticketColors.brandSoft,
  },
  railGlyph: {
    width: 18,
    textAlign: 'center',
    fontSize: 12,
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
  railLabel: {
    flex: 1,
    minWidth: 0,
    fontSize: 12.5,
    fontWeight: '600',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
  railLabelActive: {
    color: ticketColors.brandPrimary,
  },
  railPending: {
    fontSize: 12,
    fontWeight: '700',
    color: ticketColors.warn,
    marginLeft: 'auto',
  },
  railNowBadge: {
    fontSize: 10,
    fontWeight: '700',
    color: ticketColors.warn,
    backgroundColor: ticketColors.warnBg,
    borderRadius: 999,
    paddingHorizontal: 4,
    paddingVertical: 2,
  },
  railFoot: {
    marginTop: 'auto',
    paddingHorizontal: 12,
    fontSize: 11,
    fontWeight: '500',
    color: ticketColors.ink3,
    lineHeight: 15,
    fontFamily: ticketFonts.sans,
  },
  panelHeading: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 12,
    paddingBottom: 14,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
  },
  panelHeadingGlyph: {
    width: 22,
    height: 22,
    borderRadius: 6,
    backgroundColor: ticketColors.brandSoft,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  panelHeadingGlyphText: {
    fontSize: 12,
    color: ticketColors.brandPrimary,
    fontFamily: ticketFonts.sans,
    textAlign: 'center',
    lineHeight: 22,
  },
  panelHeadingLabel: {
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  panelHeadingBadge: {
    marginLeft: 'auto',
    fontSize: 11,
    lineHeight: 16,
    fontWeight: '700',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    fontFamily: ticketFonts.sans,
  },
  quickBarcodeInput: {
    borderWidth: 2,
    borderColor: ticketColors.brandPrimary,
    minHeight: 48,
    paddingVertical: 12,
    fontSize: 16,
  },
  quickScanButton: {
    width: 46,
  },
  quickPriceImageRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 12,
  },
  quickImageField: {
    flex: 1,
    minWidth: 0,
    marginBottom: 14,
  },
  quickImageButton: {
    minHeight: 44,
    justifyContent: 'center',
  },
  quickImagePreview: {
    width: 48,
    height: 48,
    borderRadius: 8,
    backgroundColor: ticketColors.bg,
  },
  railImageDropzone: {
    minHeight: 64,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 10,
    paddingHorizontal: 14,
    borderStyle: 'dashed',
    backgroundColor: ticketColors.bg,
  },
  railImagePreview: {
    width: 56,
    height: 56,
    borderRadius: 8,
    backgroundColor: ticketColors.bg,
  },
  panelColumn: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
  },
  panelScroll: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
  },
  panelContent: {
    paddingHorizontal: 26,
    paddingTop: 22,
    paddingBottom: spacing.lg,
  },
  panelNextDock: {
    flexShrink: 0,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: 26,
    paddingVertical: 8,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
  },
  panelNext: {
    alignSelf: 'flex-end',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 40,
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderWidth: 1,
    borderColor: ticketColors.brandBorder,
    borderRadius: 8,
    backgroundColor: ticketColors.brandSoft,
  },
  panelNextText: {
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.brandPrimary,
    fontFamily: ticketFonts.sans,
  },
  createMasterLink: {
    marginTop: spacing.xs,
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.sm,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.paper,
  },
  createMasterLinkText: {
    fontSize: 13,
    fontWeight: '700',
    color: ticketColors.gold,
    fontFamily: ticketFonts.sans,
  },
});

export { UOM_OPTIONS } from '@shared/quantity';
